import Model from '@/models/Model'

export default class ACancel extends Model {
  resource() {
    return 'cancel'
  }
}
